(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grande-kitchen-feature"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grande-kitchen-film')) {
  customElements.define('grande-kitchen-film', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const video = this.querySelector('video');
      const button = this.querySelector('[data-film-toggle]');
      const update = () => {button.textContent = video.paused ? button.dataset.play : button.dataset.pause;};
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(update); else video.pause();
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('ended', update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grande-pergolas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('grande-pergola-media')) {
    customElements.define('grande-pergola-media', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.addEventListener('click', event => {
          const thumb = event.target.closest('[data-pg-thumb]');
          if (!thumb || !this.contains(thumb)) return;
          const full = this.querySelector('[data-pg-full]');
          const currentImage = full.querySelector('img');
          const nextImage = thumb.querySelector('template').content.firstElementChild.cloneNode(true);
          currentImage.replaceWith(nextImage);
          full.href = thumb.dataset.full;
          this.querySelector('[data-pg-caption]').textContent = thumb.dataset.caption;
          this.querySelectorAll('[data-pg-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grande-sunrans"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sunrans-collection')){customElements.define('sunrans-collection',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const model=new URLSearchParams(window.location.search).get('enquiry_model');this.querySelectorAll('dialog[data-enquiry-model]').forEach(dialog=>{if(dialog.dataset.enquiryModel===model&&!dialog.open)dialog.showModal();});this.addEventListener('click',event=>{const opener=event.target.closest('[data-sr-open]');if(opener){const dialog=document.getElementById(opener.dataset.srOpen);if(dialog&&!dialog.open)dialog.showModal();return;}const view=event.target.closest('[data-sr-image]');if(view){const gallery=view.closest('figure');const image=gallery.querySelector('[data-sr-main]');image.src=view.dataset.srImage;image.alt=view.dataset.srAlt;gallery.querySelectorAll('[data-sr-image]').forEach(button=>button.setAttribute('aria-pressed',String(button===view)));return;}const closer=event.target.closest('[data-sr-close]');if(closer){closer.closest('dialog').close();return;}if(event.target.tagName==='DIALOG'){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grande-vegas"] && !Shopify.designMode) return;
  try {
    
  const enquiryModel = new URLSearchParams(window.location.search).get('enquiry_model');
  document.querySelectorAll('dialog[data-enquiry-model]').forEach((dialog) => {
    if (dialog.dataset.enquiryModel === enquiryModel && !dialog.open) {
      dialog.gvOpener = Array.from(document.querySelectorAll('[data-gv-open]')).find((button) => button.dataset.gvOpen === dialog.id);
      dialog.showModal();
      dialog.scrollTop = 0;
    }
  });
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-gv-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.gvOpen);
      if (dialog && !dialog.open) {
        dialog.gvOpener = opener;
        dialog.querySelectorAll('[data-gv-photo]').forEach((photo) => { photo.loading = 'eager'; });
        dialog.showModal();
        dialog.scrollTop = 0;
      }
      return;
    }
    const dialog = event.target.closest('dialog.grande-vegas-detail');
    if (!dialog) return;
    if (event.target.closest('[data-gv-close]')) {
      dialog.close();
      return;
    }
    const thumb = event.target.closest('[data-gv-thumb]');
    if (thumb) {
      dialog.querySelectorAll('[data-gv-photo]').forEach((photo) => { photo.hidden = photo.dataset.gvPhoto !== thumb.dataset.gvThumb; });
      dialog.querySelectorAll('[data-gv-thumb]').forEach((button) => { button.setAttribute('aria-pressed', String(button === thumb)); });
      const caption = dialog.querySelector('[data-gv-caption]');
      const selectedPhoto = dialog.querySelector('[data-gv-photo]:not([hidden])');
      if (caption && selectedPhoto) caption.textContent = selectedPhoto.alt;
      return;
    }
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
  document.querySelectorAll('dialog.grande-vegas-detail').forEach((dialog) => {
    dialog.addEventListener('close', () => {
      dialog.querySelectorAll('video').forEach((video) => video.pause());
      if (dialog.gvOpener && dialog.gvOpener.isConnected) dialog.gvOpener.focus({ preventScroll:true });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
